<template>
  <div :class="_.swiper">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        v-track="{
          name: '商品橱窗2-标题',
          id: `${componentId}-title`,
        }"
        :src="theme.title"
        :class="_.image"
        @click="
          theme.hasJumpButton &&
            $router.push(`/diy/list/index?componentId=${componentId}`)
        "
      />
    </div>
    <img
      v-if="theme.hasDesc && theme.descButtonImage"
      v-track="{
        name: '商品橱窗2-副标题',
        id: `${componentId}-subTitle`,
      }"
      :src="theme.descButtonImage"
      :class="_.desc"
      @click="$dmbcResourceClick(theme.targetUrl)"
    />
    <div :class="_.bdWrapper">
      <div :class="_.bd">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-track="{
            name: '商品橱窗2-商品',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: index,
            extra: getTrackExtra(item, index),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <img :src="item.icon" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.title">{{ item.title }}</div>
            <div :class="_.price">
              <div :class="_.current">
                <span>￥</span>{{ item.discountAmt }}
              </div>
              <div
                v-if="
                  theme.showDashPrice === true &&
                  +item.amt &&
                  +item.amt !== +item.discountAmt
                "
                :class="_.cost"
              >
                ￥{{ item.amt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="theme.bottomImage" :class="_.ft">
      <img :src="theme.bottomImage" :class="_.image" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .swiper {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }
    }

    .desc {
      width: 100%;
      height: auto;
    }

    .bdWrapper {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);
    }

    .bd {
      display: block;
      white-space: nowrap;
      /** 必须同时设置 y 上的，否则 iOS 13 会有拖拽效果 */
      /** 不能用简写形式（overflow: auto hidden），iPhone6s有问题 */
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      > * {
        display: inline-block;
        white-space: normal;
      }

      .item {
        width: 123px;
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;

        .cover {
          width: 123px;
          height: 123px;
          border-radius: 8px 8px 0px 0px;
          object-fit: cover;
        }

        .content {
          padding: 6px;
          background-color: #f6f4f3;

          .title {
            height: 36px;
            font-size: 13px;
            font-weight: bold;
            color: #333333;
            line-height: 18px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .price {
            margin-top: 6px;
            display: flex;
            align-items: baseline;

            .current {
              font-size: 13px;
              font-weight: bold;
              color: #ff111c;
              line-height: 16px;

              span {
                font-size: 11px;
              }
            }

            .cost {
              font-size: 10px;
              color: #bebebe;
              line-height: 12px;
              text-decoration: line-through;
            }
          }
        }

        + .item {
          margin-left: 8px;
        }
      }
    }
  }

  .ft {
    .image {
      width: 100%;
      height: auto;
    }
  }
</style>
